import { dashboard } from "../../../telemetry/TraceLogging";
import { lazyLoadModule } from "../../lazyLoadModule";
import { WidgetApi } from "../orchestrator/WidgetApi";
const TelemetryModule = import(
/* webpackChunkName: "Telemetry-Chunk" */
"../../../telemetry/Telemetry");
export class WidgetSizeApi extends WidgetApi {
    constructor(widgetInstance) {
        super(widgetInstance);
        this._instance = widgetInstance;
        this._eventListeners = new Array();
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
        }
    }
    fireStartEvent(size) {
        this.fireEvent("onSizeChangeStart", size);
    }
    fireEndEventAndUpdateSize(size) {
        this._instance.setWidgetProperty("size", size);
        this.fireEvent("onSizeChangeEnd", size);
    }
    getSize() {
        return this._instance.getWidgetProperty("size");
    }
    fireEvent(name, size) {
        lazyLoadModule(TelemetryModule).then((Telemetry) => {
            Telemetry.logEvent(dashboard, "WidgetSizeEvent", 33554432 /* productAndServiceUsage */, {
                eventType: name,
                size: size,
            });
        });
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index]) {
                this._eventListeners[index](name, size);
            }
        }
    }
}
